/*
 * Helper functions for typography
 */

export function lineHeightFromSize(size) {
  if (size < 1.1) {
    return 1.5;
  } else if (size >= 1.12 && size < 1.3) {
    return 1.4;
  } else if (size >= 1.3 && size < 1.75) {
    return 1.2;
  } else if (size >= 1.75 && size < 2.25) {
    return 1.1;
  } else if (size >= 2.25 && size < 2.75) {
    return 1.1;
  } else if (size >= 2.75) {
    return 1.1;
  }
}

export function gutterBottomFromSize(size) {
  if (size < 1.1) {
    return 0.75;
  } else if (size >= 1.12 && size < 1.3) {
    return 0.75;
  } else if (size >= 1.3 && size < 1.75) {
    return 0.75;
  } else if (size >= 1.75 && size < 2.25) {
    return 1;
  } else if (size >= 2.25 && size < 2.75) {
    return 1;
  } else if (size >= 2.75 && size < 3.5) {
    return 1.75;
  } else if (size >= 3.5) {
    return 2;
  }
}

export function cleanGutterTrueFalse(gutterBottom, size) {
  // gutterBottom must be an array, make sure it's handled by an breakPointArrayCleanerRem
  if (gutterBottom.length !== 4) return console.warn("cleanGutterTrueFalse must be an array of length 4!");

  var newArr = gutterBottom.map(function (gutter, i) {
    if (gutter === true) return gutterBottomFromSize(size[i]) + "rem";
    if (gutter === false) return "0rem";
    return gutter;
  });

  return newArr;
}